import { QuizModule, SanityQuizModule } from "@common";
import { sanityFetch } from "@natklok/util/sanity";
import groq from "groq";
import { useQuery } from "@tanstack/react-query";
import { transformSanityQuizModule } from "@natklok/sanity/transform/quizModule";

const query = groq`*[_type=="quizModule"]{
  _id,
  title,
  desc,
  topic,
  isTeacherModeQuiz,
  colors,
  isTrainingQuiz,
  icon,
  keywords[]->{
    keyword
  },
  slides[]->{
    _id
  }
}`;

function getQuizModules() {
  return sanityFetch<SanityQuizModule[]>({ query }).then((sanityQuizModules) => {
    const quizModules: Record<string, QuizModule> = {};
    sanityQuizModules.forEach((quizModule) => {
      quizModules[quizModule._id] = transformSanityQuizModule(quizModule);
    });
    return quizModules;
  });
}

export function useQuizModules() {
  const { isLoading, error, data } = useQuery({
    queryKey: ["quizModules"],
    queryFn: getQuizModules,
  });

  return { isLoading, error, data, quizModuleIds: Object.keys(data || {}) };
}
